var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStakeActionWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20.5C6.5 20.5 8.5 19 12 19C15.5 19 17.5 20.5 17.5 20.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 18.9999L12.0066 15.9989M12.0066 13.6117C12.0066 12.2819 11.1198 9.62283 8.97681 8.38626C7.27192 7.40249 5.52974 7.65882 4.37891 7.77294C4.37891 10.1509 4.8163 12.2332 6.64628 13.5263C8.73089 14.9993 10.9501 14.3258 12.0066 15.9989M12.0066 13.6117V15.9989M12.0066 13.6117C12.0066 13.1275 11.7917 12.2486 11.7917 12.2486C11.6237 11.729 11.507 11.2084 11.4597 10.68C11.2241 8.04762 12.0066 5.24598 14.7619 3.63842C17.1094 2.2688 19.0773 2.4945 20.3058 2.6185C20.6186 4.50286 20.6254 6.85269 18.6609 9.02048C16.3971 11.5185 15.3957 11.3362 13.0645 13.0506C12.3016 13.6117 12.097 14.1794 12.0066 14.5825C12.0066 14.5825 12.0066 14.3855 12.0066 13.6117Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeActionWhite);
export default __webpack_public_path__ + "static/media/stake-action-white.60c0e4f424902779d4ef3fbe54c09e92.svg";
export { ForwardRef as ReactComponent };